import React from 'react';
import $ from 'jquery';
import { ServerService } from './../../services/server.service';
import { AuditLog } from './../../services/auditlog.service';
import ReactTooltip from 'react-tooltip';
import { getUnique, formatBytes, formatBytesFloat } from '../../utility/utility';
import { appStack } from './createInstance/createInstance.Constant';
import { KB_ARTICLES_DOC } from '../../constants/server.constant';

class Rescue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            distributionImages: [],
            enablesshkey: false,
            isdatapresent: false,
            selectedImageRefId: '',
            isPsswdText: false,
            psswdStrength: 'Weak',
            errorMssg: '',
            progressPerc: 30,
            isUnrescueAction: false,
            rescueName: 'Rescuing',
            uniqueDistImages: [],
            distName: '',
            isLoaded: false,
            tabManage: 'distribution',
            applicationStack: [],
            appSlider: {
                packages: [],
                heading1Desc: [],
                heading2Desc: [],
            },
            kbArticles: [],
            isDistrHide: true,
            isImageHide: true,
            isAppImageHide: true
        };
        this.distributionClick = this.distributionClick.bind(this);
        this.imagesClick = this.imagesClick.bind(this);
    }

    loadkbArticles(name) {
        let ob = this.state.kbArticles.find(item => name === item.name);
        if(ob !== undefined) {
            let url = KB_ARTICLES_DOC + ob.uri;
            if(url) window.open(url, '_blank').focus();
            return true;
        }
        return false;
    }

    getAllKBInfo() {
        ServerService.getAllKbInfo().then(resp => {
            if(resp && Array.isArray(resp)) {
                this.setState({ kbArticles: resp });
            }
        });
    }

    showAppSlider(name) {
        if(this.loadkbArticles(name)) return;
        if(name !== undefined) {
            let appStackLoc = appStack;
            let ob = appStackLoc.find(item => name === item.key);
            if(ob === undefined) ob = appStackLoc.find(item => name.includes(item.key));
            if(ob === undefined) return;
            let elem = ob.value;
            elem.key = ob.key;
            this.setState({ appSlider: elem }, () => {
                $('#appSlider').addClass('active');
                $('.marketApp_content_wrap').scrollTop(0);
                $('body').addClass('no_scroll');
            });
        }
    }
    onMenuIconClick = (event, distribution) => {
        $(event.currentTarget).closest('.distribution_box').find('.distribute_option_dropdown').addClass('active');
        let menuDistImages = this.state.distributionImages.filter(item => item.distribution === distribution);
        if(menuDistImages[0] && menuDistImages[0].version) {
            menuDistImages.sort(function (a, b) {
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                return 0;
            });
        }
        let uniqueDistImages = this.state.uniqueDistImages;
        let selectedImageRefId = this.state.selectedImageRefId;
        // if(distribution !== sessionStorage.distName) {
        //     for(var i = 0; i < uniqueDistImages.length; i++) {
        //         uniqueDistImages[i].selectedVersion = undefined;
        //     }
        //     this.state.distributionImages.forEach(element => {
        //         element.isImage = false;
        //     });
        //     selectedImageRefId = '';
        //     $('.custom_radio').removeClass('active');
        // }
        for(var i = 0; i < uniqueDistImages.length; i++) {
            let uniqueDistImage = uniqueDistImages[i];
            if(uniqueDistImage.distribution === distribution) {
                uniqueDistImage.distImagesMenu = menuDistImages;
                if(uniqueDistImage.selectedVersion == undefined) {
                    uniqueDistImage.distImagesMenu.forEach(item1 => {
                        item1.isSelected = false;
                        item1.isImage = false;
                    });
                }
            }
        }

        this.setState({ uniqueDistImages: uniqueDistImages, selectedImageRefId: selectedImageRefId, distributionImages: this.state.distributionImages });

    };
    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.getAllKBInfo();
        this.setImageDetailsByRegion();
    }
    componentWillUnmount() {
        this.props.msgHandler("");
    }
    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };



    distributionClick = (event) => {
        $('.marketPlace_tab').removeClass('active');
        $('.marketPlaceCtnr').removeClass('active');
        $('.createdDistribute_tab').removeClass('active');
        $('#image').removeClass('active');
        $('.newDistribute_tab').addClass('active');
        $('#distribution').addClass('active');
    };
    imagesClick = (event) => {
        $('.marketPlace_tab').removeClass('active');
        $('.marketPlaceCtnr').removeClass('active');
        $('.newDistribute_tab').removeClass('active');
        $('#distribution').removeClass('active');
        $('.createdDistribute_tab').addClass('active');
        $('#image').addClass('active');
    };

    onAppImageClick(event, elem) {
        $('.distribution_box').removeClass('active');
        let imageList = this.state.applicationStack;
        imageList.forEach(item => {
            item.isSelected = false;
        });
        elem.isSelected = true;
        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
            uniqueDistImages[i].distImagesMenu.forEach(item => { item.isImage = false; item.isSelected = false; });
        }
        this.setState({ applicationStack: imageList, selectedImageRefId: elem.id, errorMssg: '', instanceName: elem.name, selectedAppImage: elem, uniqueDistImages: uniqueDistImages });
        $(event.currentTarget).addClass('active');
        $('.dropdown_component .custom_radio').removeClass('active');

    }

    setImageDetailsByRegion() {
        this.props.bgShadowHandler(true);
        ServerService.getImageDetailsByRegion(this.props.imageRegionUrl).then(flavors => {
            let distrImages = this.getNoneSuseDistr(flavors.distributionImages);
            let images = this.getNonSuseImages(flavors.images.filter(item => item.status === 'active'));
            let uniqueDistImages = getUnique(distrImages, 'distribution');
            let ob = distrImages.find(item => item.id === this.props.instance.image.id);
            if(ob === undefined) {
                ob = images.find(item => item.id === this.props.instance.image.id);
                this.setState({
                    tabManage: "image"
                });
            }
            let selectedImageRefId = '';
            if(ob !== undefined) {
                selectedImageRefId = this.props.instance.image.id;

            }
            let applicationStack = flavors.applicationStack;
            if(ob === undefined) {
                ob = applicationStack.find(item => item.id === this.props.instance.image.id);
                if(ob !== undefined) {
                    ob.isSelected = true;
                    selectedImageRefId = this.props.instance.image.id;
                    this.setState({ tabManage: "marketplace" });
                }
            }
            if(ob && ob.name === 'RancherOS-1.5.8-x86_64') {
                this.setState({
                    selectedImageRefId: selectedImageRefId,
                    isLoaded: true,
                    applicationStack: applicationStack.filter(item => item.name === 'RancherOS-1.5.8-x86_64'),
                    selectedImage: ob,
                    isAppImageHide: false
                });
            } else {
                this.setState({
                    images: images,
                    distributionImages: distrImages,
                    uniqueDistImages: uniqueDistImages,
                    selectedImageRefId: selectedImageRefId,
                    isLoaded: true,
                    applicationStack: applicationStack,
                    selectedImage: ob,
                    isDistrHide: false,
                    isImageHide: false,
                    isAppImageHide: false
                });
            }
            this.props.bgShadowHandler(false);
        });
    }

    getNoneSuseDistr(array) {
        let ob = array.find(item => item.id === this.props.instance.image.id);
        let distName = '';
        let version = '';
        let images = [];
        if(ob !== undefined && !(ob.name === 'Debian-9-x86_64')) {
            distName = ob.distribution;
            sessionStorage.distName = ob.distribution;
            ob.isImage = true;
            ob.isSelected = true;
            let instructionSet = ob.instructionSet !== undefined ? '*' + ob.instructionSet : ob.instructionSet;
            version = ob.version + instructionSet;
            ob.selectedVersion = version;
        }
        array.forEach(element => {
            if(!element.name.toLowerCase().includes('opensuse') && !(element.name === 'Debian-9-x86_64')) {
                if(element.distribution === distName) {
                    element.isSelected = true;
                    element.selectedVersion = version;
                }
                images.push(element);
            }
        });
        return images;
    }

    getNonSuseImages(array) {
        let images = [];
        array.forEach(element => {
            if(!element.name.toLowerCase().includes('opensuse')) {
                if(element.id === this.props.instance.image.id) {
                    element.isSelected = true;
                }
                images.push(element);
            }
        });
        return images;
    }
    onImageClick = (event, elem) => {
        $('.distribution_box').removeClass('active');
        let imageList = this.state.images;
        imageList.forEach(item => {
            item.isSelected = false;
        });
        elem.isSelected = true;
        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
            uniqueDistImages[i].distImagesMenu.forEach(item => { item.isImage = false; item.isSelected = false; });
        }
        this.setState({ images: imageList, selectedImageRefId: elem.id, errorMssg: '', uniqueDistImages: uniqueDistImages });
        $(event.currentTarget).addClass('active');
        $('.dropdown_component .custom_radio').removeClass('active');
    };

    distributionBoxClick = (event, distribution) => {
        //$('.distribution_box').removeClass('active');
        //$(event.currentTarget).addClass('active');
        this.onMenuIconClick(event, distribution.distribution);
    };

    distVersionSelect = (event, item, distributionImage) => {
        $('.distribution_box').removeClass('active');
        $('.custom_radio').removeClass('active');
        item.isImage = true;

        let instructionSet = item.instructionSet !== undefined ? '*' + item.instructionSet : item.instructionSet;
        let version = item.version + instructionSet;
        let uniqueDistImages = this.state.uniqueDistImages;
        sessionStorage.distName = distributionImage.distribution;

        for(var i = 0; i < uniqueDistImages.length; i++) {
            let elem = uniqueDistImages[i];
            elem.distImagesMenu.forEach(item1 => {
                item1.isImage = false;
                item1.isSelected = false;
            });
            if(distributionImage.distribution === elem.distribution) {
                elem.selectedVersion = version;
            } else {
                elem.selectedVersion = undefined;
            }
        }

        this.setState({ selectedImageRefId: item.id, uniqueDistImages: uniqueDistImages, errorMssg: '' });
        $(event.currentTarget).closest('.distribution_box').find('.distribute_option_dropdown').removeClass('active');
        $(event.currentTarget).closest('.custom_radio').addClass('active');
        $(event.currentTarget).closest('.distribution_box').toggleClass('active');
        event.stopPropagation();

    };

    isOpenSuseImage(imageId) {
        let distributionImages = this.state.distributionImages;
        let ob = distributionImages.find(item => item.id === imageId);
        if(ob === undefined) {
            return true;
        }
        return false;
    }

    onRescueClick = () => {
        let psswd = this.state.password;

        this.rescueClose();
        if((this.state.selectedAppImage && this.state.selectedAppImage.distribution === 'GitLab') || (this.state.selectedImage && this.state.selectedImage.distribution === 'GitLab')) {
            let currentFlavorOb = this.getFlavorOb(this.props.instance.flavor.id);
            if(currentFlavorOb && currentFlavorOb.ramSize < 4) {
                this.props.msgHandler('The current ram size is lesser than the 4 GB for GitLab image, Please resize to minimum 4 GB plan', 'error');
                this.clearToastMessage();
                return false;
            }
        }
        this.setState({ isUnrescueAction: true, rescueName: 'Rescuing', progressPerc: 20 });
        let requestBody = {
            rescue: {
                rescue_image_ref: this.state.selectedImageRefId
            }
        };
        let regionLog = this.props.instance.region;
        ServerService.serverAction(this.props.instance.id, this.props.computeRegionUrl, requestBody).
            then(resp => {
                //this.props.bgShadowHandler(false);

                if(resp === false) {
                    this.props.msgHandler('Failed to perform rescue on this instance, please try again ', 'error');
                    this.clearToastMessage();
                    this.setState({ isUnrescueAction: false });
                }
                if(resp || resp === "") {
                    let server = JSON.parse(sessionStorage.server);
                    const requestBody = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Instance " + server.instance.name + " has been rescued successfully",
                        "operation": "Instance Rescue",
                        "region": regionLog
                    };
                    AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                        if(resp === false);
                    });
                    //this.props.history.push('/index')
                    this.setState({ message: 'Rescuing this instance', progressPerc: 80 });
                    //this.props.updateInstStatus(this.props.instance.status);
                    //this.props.msgHandler('Rescuing with the selected image is started for this instance!', 'success');
                    // setTimeout(() => this.props.history.push('/index'), 1000);
                    setTimeout(() =>
                        this.props.history.push({
                            pathname: '/index',
                            state: {
                                val: "rescue"
                            }
                        }), 1000);
                    return;
                }
                this.props.msgHandler('Failed to rescue !', 'error');
                this.clearToastMessage();
                this.setState({ isUnrescueAction: false });
            }).catch(error => {
                this.props.msgHandler('Failed to perform rescue on this instance, please try again ', 'error');
                this.clearToastMessage();
                this.setState({ isUnrescueAction: false });
            });
    };

    handler = (event) => {
        this.setState({ [event.target.name]: event.target.value, psswdStrength: getPsswdStrength(event.target.value), errorMssg: '', psswdErrorMssg: '' });
    };
    updateUnrescueAction() {
        this.setState({ isUnrescueAction: false });
    }
    onUnrescueClick() {
        window.scrollTo(0, 0);
        this.setState({ isUnrescueAction: true, rescueName: 'Unrescuing', progressPerc: 20 });
        let requestBody = {
            unrescue: null
        };
        ServerService.serverAction(this.props.instance.id, this.props.computeRegionUrl, requestBody).
            then(resp => {
                if(resp || resp === "") {
                    this.setState({ message: 'UnRescuing this instance!', progressPerc: 80 });
                    this.props.updateInstStatus(this.props.instance.status);
                    return;
                }
                this.props.msgHandler('Failed to unrescue this instance.Try again!', 'error');
                this.clearToastMessage();
                this.setState({ isUnrescueAction: false });
            });
    }
    onPassWdKeydown = (e, type) => {
        if(e.keyCode == 13) {
            this.onRescueClick();
        }
    };
    navigateToImage() {
        this.props.history.push({
            pathname: '/images',
            state: {
                imagetype: "custom"
            }
        });
    }

    getFlavorOb(flavorId) {
        let flavorObj = undefined;
        try {

            let flavorList = JSON.parse(localStorage.getItem('flavorList'));

            if(flavorList !== null && flavorList !== undefined) {
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                    if(flavorObj) flavorObj.ramSize = flavorObj.ram / 1024;
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }

            }
        } catch(e) {
            console.log(e);
        }
        return flavorObj;
    }

    rescueClose = () => {
        $('#rescueInst').removeClass('active');
    };

    onAppTabTabClick() {
        $('.newDistribute_tab').removeClass('active');
        $('.newDistribute').removeClass('active');
        $('.createdDistribute_tab').removeClass('active');
        $('.createdDistribute').removeClass('active');
        $('.marketPlace_tab').addClass('active');
        $('.marketPlaceCtnr').addClass('active');
    }

    rescueBtnClick = () => {
        if(this.state.selectedImageRefId === undefined || this.state.selectedImageRefId === '') {
            this.props.msgHandler('Select the distribution image', 'error');
            this.clearToastMessage();
            return;
        }
        $('#rescueInst').addClass('active');
        document.getElementById('setrescueBtn').focus();
    };

    closeAppSlider() {
        $('#appSlider').removeClass('active');
        $('body').removeClass('no_scroll');
    }

    render() {
        let customAfter = {
            top: 'calc(50% - 6px)',
            left: 'calc(50% - 6px)',
            width: '11px',
            height: '12px',
            borderRadius: '50%',
            background: '#1988fa'
        };
        const backupCss = `
         .stb{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;
        const customCss = `
         .st0{display:none;}
         .st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
         .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;

        const snapCss = `
        .sts{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;

        let uniqueDistImages = this.state.uniqueDistImages;
        uniqueDistImages.forEach(item => {
            if(item.distImagesMenu === undefined) item.distImagesMenu = [];
        });

        return (
            <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper rebuild_setting_module" }>
                { this.props.instance.isdatapresent ? <div>
                    <div className="outer_empty_wrap">
                        <div className="inner_empty_wrap">
                            <div className="svg_wrap empty_icon rebuild_empty"></div>
                            <p className="empty_title" >No Rescue</p>
                        </div>
                    </div>
                </div> : <div>
                        <div className="boot_container" style={ { display: this.state.isUnrescueAction ? 'block' : 'none' } }>
                            <div className="boot_wrapper">
                                <div className="progress_wrap">
                                    <div className="title_head"><span className="head_title">{ this.state.rescueName }</span><span className="percent_num">{ this.state.progressPerc + '%' }</span></div>
                                    <div className="progress_bar"><span className="percent_progress" style={ { width: this.state.progressPerc + '%' } }></span></div>
                                </div>
                            </div>
                        </div>
                        <div className="settModule_head_wrap" >
                            <div className="settModule_head_lhs">
                                <h2>Rescue</h2>
                                <p className="head_info">Boot the instance in rescue mode if it is unable to boot in the normal mode</p>
                            </div>
                        </div>
                        <div className="rebuildModule_wrap clearfix">
                            <section className="distribute_sec" >
                                {/* <span className="comm_error_msg">{this.state.errorMssg}</span> */ }
                                <div className="custom_tabs_wrap">
                                    <ul>
                                        <li className={ this.state.tabManage === "distribution" ? "newDistribute_tab active" : "newDistribute_tab" } onClick={ this.distributionClick } style={ { display: this.state.isDistrHide ? 'none' : '' } }>Choose a Distribution</li>
                                        <li className={ this.state.tabManage === "image" ? "createdDistribute_tab active" : "createdDistribute_tab" } onClick={ this.imagesClick } style={ { display: this.state.isImageHide ? 'none' : '' } }>Images</li>
                                        <li className={ this.state.tabManage === "marketplace" ? "marketPlace_tab active" : "marketPlace_tab" } onClick={ () => this.onAppTabTabClick() } style={ { display: this.state.isAppImageHide ? 'none' : '' } }>Application Stack</li>
                                    </ul>
                                </div>
                                <div className="distribute_box_container clearfix">
                                    <div className={ this.state.tabManage === "distribution" ? "dist_box_wrap newDistribute active" : "dist_box_wrap newDistribute" } id="distribution">
                                        {/* <p className="distribution_info" >Select an appropriate Linux distribution</p> */ }
                                        {/* this.state.uniqueDistImages.length === 0 ?
                                            <div className="inner_empty_wrap">
                                                <div className={"svg_wrap empty_icon summary_empty rescue_empty"}></div>
                                                <p className="empty_title">No Distribution found</p>
                                            </div> :  */}
                                        { this.state.uniqueDistImages.map((distributionImage, i) => <div className={ distributionImage.isSelected ? "distribution_box active" : "distribution_box" } key={ i } onClick={ (e) => this.distributionBoxClick(e, distributionImage) }>
                                            <div className="os_Img">
                                                <div className={ "icon_img " + distributionImage.distribution.toLowerCase() }>
                                                    <span className="icon">
                                                        <svg x="0px" y="0px" viewBox="0 0 28.6 26.6" style={ { display: distributionImage.distribution.toLowerCase() == 'rocky linux' ? 'block' : 'none' } } enableBackground="new 0 0 28.6 26.6;" xmlSpace="preserve">
                                                            <g>
                                                                <path class="rk0" d="M21.4,14.2c0.4-1.1,0.6-2.3,0.6-3.5C22,4.8,17.2,0,11.3,0S0.6,4.8,0.6,10.7c0,2.9,1.2,5.6,3.1,7.5L14.5,7.4
                                                        L21.4,14.2L21.4,14.2z M19.5,17.6l-4.9-4.9l-7.7,7.7c1.4,0.6,2.9,1,4.5,1C14.6,21.3,17.5,19.9,19.5,17.6L19.5,17.6z"></path>
                                                            </g>
                                                        </svg>
                                                        <svg id="Layer_1" x="0px" y="0px" width="28.6px" height="26.6px" viewBox="0 0 28.6 26.6" style={ { display: distributionImage.distribution.toLowerCase() == 'almalinux' ? 'block' : 'none' } } enableBackground="new 0 0 28.6 26.6;" xmlSpace="preserve">
                                                            <g>
                                                                <path id="path22" class="al0" d="M19.8,11.9c0.9-0.1,1.7,0.5,1.7,1.4c0.1,1-0.6,1.7-1.5,1.8c-0.9,0.1-1.7-0.6-1.7-1.5
                                                                    C18.2,12.7,18.8,12,19.8,11.9z"></path>
                                                                <path id="path24" class="al0" d="M8.6,19.4c0-0.9,0.7-1.6,1.6-1.6s1.7,0.8,1.7,1.7c0,0.8-0.7,1.6-1.5,1.6
                                                                    C9.3,21.1,8.6,20.4,8.6,19.4z"></path>
                                                                <path id="path26" class="al0" d="M11.1,9.1c-0.1,0.1-0.2,0-0.2-0.1C9.6,6.6,10,3.5,12.3,1.7c0.6-0.5,1.7-0.6,2.2-0.1
                                                                    c0.2,0.2,0.2,0.4,0.3,0.6c0.1,0.5,0.2,1.1,0.5,1.5c0.4,0.5,0.9,0.6,1.4,0.6s1-0.1,1.3,0.5c0.2,0.3,0.1,1.6-0.2,1.8
                                                                    c-0.1,0.1-0.2,0-0.4,0c-0.8-0.3-1.7-0.3-2.5-0.2c-0.3,0-0.4,0-0.4-0.4c0-0.5-0.1-1-0.4-1.5c-0.5-1-1.5-1-2.2-0.1
                                                                    c-0.5,0.7-0.7,1.6-0.8,2.4C11.1,7.6,11.1,8.3,11.1,9.1L11.1,9.1z"></path>
                                                                <path id="path28" class="al0" d="M12,9.6c-0.1-0.1,0-0.2,0.1-0.3c2-1.8,5-2.2,7.3-0.4c0.6,0.5,1,1.5,0.7,2.1
                                                                    c-0.1,0.2-0.3,0.4-0.5,0.4c-0.5,0.2-1,0.4-1.3,0.9s-0.4,1-0.2,1.6c0.1,0.5,0.3,1-0.2,1.4c-0.2,0.2-1.4,0.5-1.8,0.2
                                                                    C16,15.4,16,15.3,16,15.1c0.1-0.9-0.1-1.7-0.4-2.5c-0.1-0.3-0.1-0.4,0.2-0.5c0.5-0.1,1-0.4,1.3-0.7c0.8-0.7,0.6-1.7-0.4-2.1
                                                                    C15.9,8.9,15,9,14.2,9.1C13.5,9.2,12.7,9.4,12,9.6z"></path>
                                                                <path id="path30" class="al0" d="M11.6,10.6c0.1-0.1,0.2-0.1,0.3,0c2.3,1.4,3.5,4.2,2.5,6.9c-0.3,0.7-1.2,1.4-1.9,1.2
                                                                    c-0.3-0.1-0.4-0.2-0.6-0.4c-0.3-0.4-0.7-0.8-1.2-1c-0.6-0.2-1.1-0.1-1.6,0.2c-0.4,0.2-0.8,0.6-1.4,0.2c-0.3-0.2-0.8-1.3-0.7-1.6
                                                                    C7.1,16,7.2,16,7.4,16c0.9-0.1,1.6-0.6,2.3-1.1c0.2-0.2,0.4-0.2,0.6,0.1c0.3,0.4,0.6,0.8,1.1,1c0.9,0.5,1.8,0.1,1.9-1
                                                                    c0.1-0.9-0.2-1.7-0.5-2.4C12.4,11.9,12,11.2,11.6,10.6z"></path>
                                                                <path id="path32" class="al0" d="M10.4,10.8c-0.1,0.7-0.5,1.4-0.9,2c-1.3,1.9-3.1,2.7-5.4,2.5c-0.8-0.1-1.5-0.7-1.6-1.4
                                                                    c0-0.3,0-0.5,0.2-0.7c0.2-0.3,0.5-0.6,0.6-1c0.2-0.8-0.1-1.4-0.6-2C1.9,9.4,2,8.7,2.9,8.2C3,8.1,3.1,8.1,3.3,8
                                                                    c0.2-0.1,0.4-0.1,0.5,0.1c0.3,0.8,1,1.4,1.7,1.9c0.2,0.2,0.2,0.4,0,0.6c-0.4,0.5-0.7,1-0.7,1.7c-0.1,0.8,0.4,1.3,1.2,1.3
                                                                    c0.5,0,1-0.2,1.4-0.4c1.1-0.6,1.9-1.4,2.7-2.2C10.3,10.8,10.3,10.7,10.4,10.8z"></path>
                                                                <path id="path34" class="al0" d="M4.7,3.4c0.1,0,0.2,0,0.4,0.1c1.3,0.2,2.1-0.2,2.5-1.4C7.9,1.3,8.5,1,9.3,1.5c0,0,0,0,0.1,0
                                                                    C10.2,2,10.2,2,9.7,2.7C9.3,3.3,9.1,3.9,9,4.6C8.9,5,8.8,5.1,8.4,4.9c-0.6-0.2-1.2-0.2-1.8,0c-0.7,0.2-1,0.8-0.7,1.5
                                                                    C6.2,7.3,7,7.7,7.6,8.1c0.7,0.5,1.4,0.7,2.2,1c0.1,0,0.3,0,0.2,0.2c0,0.1-0.2,0.1-0.3,0.1C8.1,9.5,6.6,9.2,5.4,8.2s-2-2.1-1.9-3.7
                                                                    C3.6,3.9,4,3.5,4.7,3.4z"></path>
                                                                <path id="path36" class="al0" d="M1.8,13.3C1,13.4,0.1,12.7,0,11.8C-0.1,11,0.6,10.1,1.4,10c0.9-0.1,1.8,0.5,1.8,1.4
                                                                    C3.3,12.2,2.8,13.2,1.8,13.3z"></path>
                                                                <path id="path38" class="al0" d="M16.6,0.7c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.8-0.6,1.7-1.5,1.7C16,4,15.2,3.3,15.1,2.4
                                                                    C15,1.6,15.7,0.8,16.6,0.7z"></path>
                                                                <path id="path40" class="al0" d="M7.4,1.4c0.1,0.9-0.5,1.7-1.5,1.8C5.1,3.3,4.2,2.6,4.1,1.9C4,0.9,4.6,0.1,5.5,0S7.3,0.6,7.4,1.4z"></path>
                                                            </g>
                                                        </svg>
                                                        <svg x="0px" y="0px" style={ { display: distributionImage.distribution.toLowerCase() === 'fedora' ? 'block' : 'none' } }
                                                            viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                            <circle display="none" fill="#DCA5CA" cx="15" cy="15" r="14" />
                                                            <g>
                                                                <path fill="#FFFFFF" d="M17.1,3C11.5,1.9,5.4,5.5,3.5,11.3c-0.9,2.6-0.6,5.1-0.7,7.7c0,8.8-0.6,8.2,8.3,8.2c1.4,0,2.8,0,4.1,0
c6.2-0.2,11.2-4.9,11.9-11C27.7,9.9,23.4,4.1,17.1,3z M18.4,16.9L18.4,16.9h-3.1v3c0,2.9-2.3,5.2-5.2,5.2c-0.6,0-1-0.4-1-1
s0.4-1,1-1c1.8,0,3.1-1.3,3.1-3.1v-3.1h-3.1c-0.7,0-1.1-0.4-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1v-3.1c0-2.9,2.3-5.2,5.2-5.2
c0.6,0,1,0.4,1,1.1s-0.4,1.1-1,1.1c-1.8,0-3.1,1.3-3.1,3.1v3.1h3.1c0.6,0,1,0.5,1,1C19.4,16.5,19,16.9,18.4,16.9z"/>
                                                                <g>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.3,11.3c0-0.1,0-0.1,0-0.2C15.4,11.2,15.3,11.2,15.3,11.3z"
                                                                    />
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.6,9.2L16.6,9.2L16.6,9.2z" />
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.4,10.8c0-0.1,0.1-0.2,0.1-0.3
C15.5,10.6,15.5,10.7,15.4,10.8z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M14.7,8c-0.2,0.2-0.3,0.3-0.4,0.5C14.4,8.3,14.6,8.2,14.7,8z"
                                                                    />
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.5,7.4c-0.1,0.1-0.2,0.1-0.3,0.2
C15.3,7.5,15.4,7.4,15.5,7.4z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15.7,10.3c0.1-0.1,0.1-0.2,0.2-0.3
C15.8,10.1,15.7,10.2,15.7,10.3z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M16.2,9.5c-0.1,0.1-0.1,0.1-0.2,0.2
C16.1,9.7,16.1,9.6,16.2,9.5z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.2,11.7c0-0.7,0.1-1.4,0.4-2C13.3,10.3,13.2,10.9,13.2,11.7
z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.2,25c-0.3,0.1-0.6,0.1-0.9,0.1
C10.6,25.1,10.9,25.1,11.2,25z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M18.5,6.5C19,6.6,19.4,7,19.4,7.6c0,0.7-0.4,1.1-1,1.1
c1.7,0,3.1,1.3,3.1,3.1c0,1.7-1.3,3.1-3.1,3.1l0,0c0.5,0,1,0.5,1,1c0,0.7-0.4,1.1-1,1.1l0,0l0,0c2.9,0,5.2-2.4,5.2-5.3
C23.6,8.8,21.3,6.6,18.5,6.5z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M15,21.6c0.1-0.2,0.2-0.4,0.2-0.7C15.1,21.2,15.1,21.4,15,21.6
z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M13.6,9.6c0.1-0.3,0.3-0.6,0.5-0.8C13.9,9,13.7,9.3,13.6,9.6z"
                                                                    />
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M11.4,24.9c1.6-0.4,2.9-1.5,3.5-3C14.3,23.4,13,24.5,11.4,24.9
z"/>
                                                                    <path opacity="0.5" fill="#C0C7C9" enableBackground="new " d="M9.1,24.1c0-0.6,0.4-1,1-1c0.8,0,1.5-0.3,2-0.7
c-0.5,0.5-1.2,0.7-2.1,0.7c-1.8,0-3.1-1.3-3.1-3.1c0-1.8,1.3-3.1,3.1-3.1l0,0c-0.6,0-1.1-0.5-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1h3.1
H9.9c-2.9,0-5.2,2.4-5.2,5.3s2.4,5.1,5.3,5.1l0,0C9.6,25.1,9.1,24.7,9.1,24.1z"/>
                                                                </g>
                                                            </g>
                                                        </svg>

                                                        <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distributionImage.distribution.toLowerCase() === 'debian' ? 'block' : 'none' } }>
                                                            <path fill="#FFFFFF" d="M12.1,27.2c-0.7-0.3-1.4-0.6-2.1-1c-1.4-0.8-2.5-1.9-3.4-3.2c-0.5-0.7-0.9-1.4-1.2-2.1  c-0.3-0.7-0.6-1.5-0.8-2.2c-0.2-0.8-0.4-1.6-0.5-2.4c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.7,0.6-3.3,1.4-4.8C6,8.2,6.4,7.5,7,6.9  c0.5-0.7,1.2-1.3,1.8-1.8c2.8-2.1,6.5-2.8,9.9-1.9c0.8,0.2,1.7,0.6,2.4,1c0.8,0.4,1.5,1,2.2,1.7c2.6,2.7,3.4,6.5,2.1,10  c-0.7,1.7-1.9,3.1-3.5,4.1c-1.6,0.9-3.5,1.2-5.2,0.8c-0.9-0.2-1.7-0.6-2.4-1.2c-0.7-0.6-1.2-1.3-1.6-2.1c-0.3-0.8-0.5-1.7-0.4-2.6  c0.1-0.9,0.5-1.7,1.1-2.3c0.5-0.7,1.2-1.1,2-1.3c0.8-0.1,0.8,0.2,0.1,0.5c-0.6,0.3-1.1,0.8-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.8  c0,0.6,0.2,1.2,0.6,1.7c0.6,1,1.7,1.7,2.9,1.9c1.2,0.2,2.4-0.1,3.3-0.8c0.9-0.7,1.6-1.7,2-2.8c0.3-1.1,0.4-2.4,0.1-3.5  c-0.3-1.1-0.9-2.2-1.7-3c-0.4-0.4-0.9-0.7-1.4-1c-0.5-0.3-1.1-0.5-1.7-0.7c-0.6-0.2-1.2-0.3-1.8-0.4c-0.6,0-1.2,0-1.8,0.1  c-1.2,0.2-2.4,0.7-3.4,1.4c-2.1,1.5-3.5,3.8-4,6.4c-0.2,1.3-0.2,2.7,0,4c0.1,0.7,0.3,1.3,0.5,2c0.2,0.7,0.5,1.3,0.8,2  c0.6,1.3,1.5,2.4,2.6,3.3C11.5,26,12.8,27.5,12.1,27.2z"></path>
                                                        </svg>
                                                        <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distributionImage.distribution.toLowerCase() === 'ubuntu' ? 'block' : 'none' } }>
                                                            <circle fill="#FFFFFF" cx="6.1" cy="15" r="2.1"></circle>
                                                            <circle fill="#FFFFFF" cx="22.4" cy="24.5" r="2.1"></circle>
                                                            <circle fill="#FFFFFF" cx="22.4" cy="5.6" r="2.1"></circle>
                                                            <path fill="#FFFFFF" d="M16.9,20.1c-0.6,0-1.2-0.1-1.7-0.3l-2.1,3.6c1.2,0.5,2.5,0.8,3.8,0.8c0.6,0,1.3-0.1,1.9-0.2  c0.3-2,2.1-3.4,4.1-3.2c0.3,0,0.6,0.1,0.9,0.2c1.3-1.4,2.1-3.2,2.3-5.1h-4.1C21.4,18.3,19.3,20.1,16.9,20.1z"></path>
                                                            <path fill="#FFFFFF" d="M23.8,9c-1.9,0.8-4-0.2-4.8-2.1c-0.1-0.3-0.2-0.6-0.2-0.9c-0.6-0.1-1.2-0.2-1.9-0.2c-1.4,0-2.8,0.3-4,0.9  l2.4,3.4c2.7-0.8,5.5,0.7,6.4,3.3c0.1,0.2,0.1,0.4,0.2,0.7H26C25.8,12.3,25,10.4,23.8,9z"></path>
                                                            <path fill="#FFFFFF" d="M8.2,12c1.7,1.2,2.1,3.5,0.9,5.1c-0.2,0.3-0.5,0.6-0.9,0.9c0.6,1.8,1.8,3.3,3.3,4.4l2.1-3.6  c-2.1-1.8-2.4-5.1-0.5-7.2c0.2-0.2,0.4-0.5,0.7-0.7l-2.4-3.3C9.9,8.8,8.8,10.3,8.2,12z"></path>
                                                        </svg>
                                                        <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distributionImage.distribution.toLowerCase() === 'centos' ? 'block' : 'none' } }><g><path fill="#FFF" d="M13.1,14.1l0.9,0.9l-0.9,0.9H7v2.9l-3.7-3.7L7,11.3v2.8H13.1L13.1,14.1L13.1,14.1L13.1,14.1z M15.8,6.8h7.4   v7.4h-7.4V6.8L15.8,6.8L15.8,6.8L15.8,6.8z"></path><path fill="#FFF" d="M15.8,13.1L15,13.9l-0.9-0.9V7h-2.9L15,3.3L18.6,7h-2.8V13.1L15.8,13.1L15.8,13.1L15.8,13.1z M15.8,15.8   h7.4v7.4h-7.4V15.8L15.8,15.8L15.8,15.8L15.8,15.8z"></path><path fill="#FFF" d="M16.8,15.8L16,15l0.9-0.9h6.1v-2.9l3.7,3.7l-3.7,3.7v-2.8H16.8L16.8,15.8L16.8,15.8L16.8,15.8z M6.8,15.8   h7.4v7.4H6.8V15.8L6.8,15.8L6.8,15.8L6.8,15.8z"></path><path fill="#FFF" d="M14.1,16.8l0.9-0.9l0.9,0.9v6.1h2.9l-3.7,3.7l-3.7-3.7h2.8V16.8L14.1,16.8L14.1,16.8L14.1,16.8z M6.8,6.8   h7.4v7.4H6.8V6.8L6.8,6.8L6.8,6.8L6.8,6.8z"></path><path fill="#dda4cb" d="M6.5,6.5h7.9v7.9H6.5V6.5L6.5,6.5L6.5,6.5L6.5,6.5L6.5,6.5z M7,13.9h6.9V7H7V13.9L7,13.9L7,13.9L7,13.9z    M15.5,6.5h7.9v7.9h-7.9V6.5L15.5,6.5L15.5,6.5L15.5,6.5z M16,13.9h6.9V7H16V13.9L16,13.9L16,13.9L16,13.9z M15.5,15.5h7.9v7.9   h-7.9V15.5L15.5,15.5L15.5,15.5L15.5,15.5z M16,22.9h6.9V16H16V22.9L16,22.9L16,22.9L16,22.9z M6.5,15.5h7.9v7.9H6.5V15.5L6.5,15.5   L6.5,15.5L6.5,15.5z M7,22.9h6.9V16H7V22.9L7,22.9L7,22.9L7,22.9L7,22.9z"></path><path fill="#dda4cb" d="M8.6,20.6L3,15l5.6-5.6l5.6,5.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6L8.6,20.6z M3.7,15l4.9,4.9   l4.9-4.9l-4.9-4.9L3.7,15L3.7,15L3.7,15L3.7,15z M15,14.2L9.3,8.6L15,3l5.6,5.6L15,14.2L15,14.2L15,14.2L15,14.2z M10.1,8.6   l4.9,4.9l4.9-4.9L15,3.7L10.1,8.6L10.1,8.6L10.1,8.6L10.1,8.6z M21.3,20.6L15.7,15l5.6-5.6l5.6,5.6L21.3,20.6L21.3,20.6L21.3,20.6   L21.3,20.6z M16.5,15l4.9,4.9l4.9-4.9l-4.9-4.9L16.5,15L16.5,15L16.5,15L16.5,15z M15,26.9l-5.6-5.6l5.6-5.6l5.6,5.6L15,26.9   L15,26.9L15,26.9L15,26.9z M10.1,21.3l4.9,4.9l4.9-4.9L15,16.5L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3L10.1,21.3z"></path></g></svg>

                                                        <svg x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve" style={ { display: distributionImage.distribution.toLowerCase() === 'opensuse leap' ? 'block' : 'none' } }>
                                                            <g>
                                                                <path fill="#FFFFFF" d="M23.6,13.7c0.6,0.3,1.3,0.4,2.1,0.3c0.6-0.1,1.2-0.4,1.7-0.8c0.1-0.1,0.1-0.1,0.1-0.3
		c-0.2-0.6-0.4-1.3-0.6-1.9c-0.3-0.6-0.7-1.1-1.3-1.3c-1.6-0.6-3.2-1-4.9-1.3c-0.1,0-0.2,0-0.2,0.1c0,0.2,0,0.4,0,0.6
		c0,0.2,0,0.2-0.2,0.1c-2.3-0.7-2.7-1.1-5.2-1.1c-2.1,0-4,0.4-5.9,1.2C7.4,10,5.7,11,4.5,12.4c-1.1,1.3-2,2.7-2.1,4.4
		c-0.1,1.3,0.3,2.5,1.3,3.5c1.1,1.1,2.4,1.5,3.9,1.3c2.2-0.2,3.1-2.1,3-3.5c-0.2-1.7-1.9-3.1-3.6-2.7c-1.3,0.3-2.1,1.5-1.6,2.7
		c0.4,1,1.7,1.4,2.5,0.9c0.3-0.2,0.4-0.4,0.3-0.7C8,18,7.7,17.9,7.4,17.9c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.9-0.2-0.7-0.7
		c0.1-0.3,0.3-0.4,0.5-0.5c0.5-0.2,1.3,0,1.7,0.5c0.9,1,0.4,2.5-0.9,2.8c-0.3,0.1-0.5,0.1-0.8,0.1c-1.5,0-2.8-1.3-2.8-2.8
		c0-1.2,0.7-2.3,1.9-2.8c1-0.4,2.1-0.3,3.1,0.2c1.5,0.7,2.6,1.9,3.1,3.6c0,0.1,0.1,0.2,0.2,0.3c0.4,0.3,1,0.4,1.4,0.7
		c0.1,0,0.1,0.1,0.2,0c-0.1-0.4-0.1-0.9-0.1-1.3c0-1.1,0.5-1.9,1.5-1.8c0.5,0,0.4-0.3,1.2,0.4c0.4,0.4,0.4,1.3,0.9,1.8
		c0.2,0.2,0.4,0.4,0.5,0.5c0.6,0.3,1.3,0.5,1.8,0.8c0.1,0,0.1,0.1,0.2,0c0-0.1-0.1-0.2-0.2-0.3c-0.4-0.5-0.6-1-0.8-1.6
		c-0.1-0.4-0.2-0.9-0.1-1.3c0.1-0.4,0.4-0.6,0.8-0.7c0.3,0,0.5,0,0.8,0c0.9,0.1,1.8,0.2,2.7,0.2c1.2-0.1,2.2-0.4,3.3-0.9
		c0.4-0.2,0.7-0.5,0.8-1.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.7,0.3-1.4,0.4-2.2,0.3
		c-1-0.3-1.8-0.6-2.7-1.1c0,0-0.1,0-0.1-0.1c-0.2-0.3-0.3-0.6-0.4-1c0.1,0,0.2,0.1,0.3,0.2C22.1,13,22.8,13.4,23.6,13.7z M24.6,10.1
		c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C23,10.9,23.7,10.1,24.6,10.1z"></path>
                                                                <path fill="#FFFFFF" d="M24.5,12.8c0.6,0,1.2-0.4,1.2-1.1c0-0.6-0.4-1.2-1.1-1.2s-1.2,0.4-1.2,1.1C23.4,12.3,23.9,12.8,24.5,12.8z
		 M24.8,11.2c0.3,0,0.5,0.1,0.5,0.3s-0.2,0.4-0.5,0.4c-0.3,0-0.4-0.1-0.4-0.3C24.3,11.3,24.5,11.2,24.8,11.2z"></path>
                                                            </g>
                                                        </svg>

                                                    </span>

                                                </div>
                                            </div>
                                            <div className="os_desc">
                                                <div className="desc_wrap">
                                                    <div className="dist_name text_elipses">{ distributionImage.distribution }</div>
                                                    <div className="dist_version">{ distributionImage.selectedVersion === undefined ? 'Select Version' : distributionImage.selectedVersion }</div>
                                                </div>
                                            </div>
                                            <div className="menu_icon" onClick={ (e) => this.onMenuIconClick(e, distributionImage.distribution) }>
                                                <svg
                                                    x="0px"
                                                    y="0px"
                                                    viewBox="0 0 4.9 17.1"
                                                    enableBackground="new 0 0 4.9 17.1"
                                                    xmlSpace="preserve">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        fill="#7A8E9D"
                                                        d="M2.5,10.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S3.6,10.5,2.5,10.5  z M2.5,4.4c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C4.5,3.6,3.6,4.4,2.5,4.4z M2.5,12.6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2  S1.4,12.6,2.5,12.6z"></path>
                                                </svg>
                                            </div>
                                            <ul className="dropdown_component distribute_option_dropdown">
                                                <span className="arrow_pointer"></span>
                                                { distributionImage.distImagesMenu.map((item, i) =>
                                                    <li className="opt1" key={ i }>
                                                        <label className={ item.isImage ? "custom_radio active" : "custom_radio" }>{ item.version }{ item.instructionSet !== undefined ? '*' + item.instructionSet : item.instructionSet }
                                                            <input type="radio" name="distribute_options_box1" onClick={ (e) => this.distVersionSelect(e, item, distributionImage) } />
                                                            <span className="checkmark"></span>
                                                            {/* {item.id===this.props.instance.image.id?<span className="checkmark" style={customAfter}></span>:<span className="checkmark"></span>} */ }
                                                        </label>
                                                    </li>
                                                ) }
                                            </ul>
                                        </div>)
                                        }

                                    </div>
                                    <div className={ this.state.tabManage === "image" ? "dist_box_wrap createdDistribute active" : "dist_box_wrap createdDistribute" } id="image">
                                        {/* <p className="distribution_info" >Add a new custom image of a virtual hard disk</p> */ }
                                        {
                                            this.state.images.map((image, i) =>
                                                <div className={ image.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onImageClick(e, image) } key={ i }>
                                                    <div className="os_Img">
                                                        <div className={ "icon_img " + image.image_type }>
                                                            <span className="icon" style={ { display: image.image_type === 'backup' ? '' : 'none' } }>
                                                                <svg x="0px" y="0px"
                                                                    viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                    <style type="text/css">{ backupCss }</style>
                                                                    <g>
                                                                        <path className="stb" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
			c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                        <path className="stb" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
			c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                        <path className="stb" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
			c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                        <path className="stb" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
			C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                            <span className="icon" style={ { display: image.image_type === 'snapshot' ? '' : 'none' } }>
                                                                <svg x="0px" y="0px"
                                                                    viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                    <style type="text/css">{ snapCss }</style>
                                                                    <path className="sts" d="M150.7,150.7H41.3c-8.6,0-15.6-7-15.6-15.6V72.6c0-8.6,7-15.6,15.6-15.6h13l2.6-7.8c0-4.3,3.5-7.8,7.8-7.8h62.5
	c4.3,0,7.8,3.5,7.8,7.8l2.6,7.8h13c8.6,0,15.6,7,15.6,15.6v62.5C166.3,143.7,159.3,150.7,150.7,150.7z M115.5,49.1H76.5
	c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9h39.1c2.2,0,3.9-1.8,3.9-3.9S117.7,49.1,115.5,49.1z M96,72.6c-17.3,0-31.3,14-31.3,31.3
	s14,31.3,31.3,31.3s31.3-14,31.3-31.3S113.3,72.6,96,72.6z M96,119.4c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6
	S104.6,119.4,96,119.4z"/>
                                                                </svg>
                                                            </span>
                                                            <span className="icon" style={ { display: image.image_type === undefined ? '' : 'none' } }>
                                                                <svg y="0px"
                                                                    viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                    <style type="text/css">{ customCss }</style>
                                                                    <g className="st0">
                                                                        <path className="st1" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
		c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                        <path className="st1" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
		c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                        <path className="st1" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
		c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                        <path className="st1" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
		C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                    </g>
                                                                    <g>
                                                                        <path className="st2" d="M112.7,69.4H59.4V76h53.3V69.4z M66,93.1v-7.7c0-1.5-1.2-2.8-2.8-2.8H42.6c-1.4,0-2.3-1.6-1.6-2.8l15.1-25.1
		c2-3.3,5.6-5.4,9.5-5.4h40.7c3.9,0,7.5,2,9.5,5.4l12.9,21.4c1.3-0.1,2.6-0.2,3.9-0.2c2,0,4,0.2,6,0.5l-15.8-27.6
		c-2.2-3.8-6.3-6.2-10.7-6.2H59.8c-4.4,0-8.5,2.4-10.7,6.2L28.3,85.4c-1.5,2.6-2.2,5.5-2.2,8.4v35.4c0,3.7,3,6.7,6.7,6.7h65.3
		c-3.4-5.9-5.4-12.7-5.4-20c0-7.3,2-14.1,5.4-20H68.9C67.3,96,66,94.7,66,93.1z M132.6,82.7c-18.4,0-33.3,14.9-33.3,33.3
		s14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3S151,82.7,132.6,82.7z M136.9,142.3c-18,2.8-33.3-12.5-30.5-30.5
		c1.7-11.2,10.9-20.4,22.1-22.1c18-2.8,33.3,12.5,30.5,30.5C157.2,131.4,148.1,140.6,136.9,142.3z M126,122.6v13.3h13.3v-13.3h13.3
		l-20-26.6l-20,26.6H126z M66,56v6.7h40V56H66z"/>
                                                                    </g>
                                                                </svg>

                                                            </span>

                                                        </div>

                                                    </div>
                                                    <div className="os_desc">
                                                        <div className="desc_wrap">
                                                            <div className="dist_name text_elipses" data-tip data-for={ image.name }>{ image.name }<ReactTooltip id={ image.name } place="top" effect="solid">{ image.name }</ReactTooltip></div>
                                                            {/* <div className="dist_version text_elipses"><span style={{display:image.image_type?'':'none'}}>{image.image_type},</span> Size {formatBytesFloat(image.size)}, Min-Disk {image.min_disk}GB </div> */ }
                                                            <div className="dist_version text_elipses" style={ { display: image.min_disk > 0 ? '' : 'none' } }>Minimum storage disk required : { image.min_disk } GB </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        }
                                        <div className="cta_wrap">
                                            <p className="distribution_info dbw_desc" style={ { display: this.state.images.length === 0 ? '' : 'none' } }>Upload an image from hard disk or import via URL to create an instance with custom OS of your choice. Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                            <p className="distribution_info dbw_desc" style={ { display: this.state.images.length > 0 ? '' : 'none' } }>Click <span onClick={ () => this.navigateToImage() } style={ { color: '#3183e6', cursor: 'pointer' } }>here</span> to upload a new custom image.</p>
                                        </div>
                                    </div>
                                    <div className={ this.state.tabManage === "marketplace" ? "dist_box_wrap marketPlaceCtnr active" : "dist_box_wrap marketPlaceCtnr" }>
                                        { this.state.applicationStack.map((appImage, i) =>
                                            <div key={ i } className={ appImage.isSelected ? "distribution_box active" : "distribution_box" } onClick={ (e) => this.onAppImageClick(e, appImage) }>
                                                <div className="os_Img">
                                                    <div className={ "icon_img " + appImage.rawName.replace(/[&\s]/g, '').toLowerCase() }>
                                                        <span className="icon">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="os_desc">
                                                    <div className="desc_wrap">
                                                        <div className="dist_name text_elipses" title={ appImage.nameDesc } >{ appImage.rawName } { appImage.nameDesc !== undefined ? ':' + appImage.nameDesc : '' }</div>
                                                        <div className="dist_version">on { appImage.os } { appImage.version }</div>
                                                    </div>
                                                </div>
                                                <div className="marketInf_icon" onClick={ () => this.showAppSlider(appImage.rawName.toLowerCase()) }>
                                                    <span className="question_icon active" data-toggle="tooltip" data-placement="bottom" title="View app details" data-original-title="View app details">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#fff" stroke="#739bb2" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 9.0724 15.4681)" fill="#739bb2" fontFamily="'Roboto-Medium'" fontSize="14px">i</text>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>

                                        ) }
                                    </div>
                                </div>
                            </section>

                            <input type="button" name="" value="Rescue" className={ !this.props.isTaskStateNull ? "common_cta_btn blue disabled" : "common_cta_btn blue" } disabled={ !this.props.isTaskStateNull } onClick={ () => this.rescueBtnClick() } style={ { display: this.state.isLoaded ? '' : 'none' } } />
                            {/* <input type="button" name="" value="Unrescue" className="common_cta_btn blue" onClick={() => this.onUnrescueClick()} style={{ display: this.props.instance.status.toLowerCase() === 'active' ? 'none' : 'block' }} /> */ }
                        </div>
                    </div>
                }
                <div className="main_popup delete_instanceSetting_popup" id="rescueInst">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ this.rescueClose }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Rescue</div>
                                </div>
                                <div className="popup_body">
                                    <p className="imp_warn_note"><strong>Warning:</strong> The instance will be powered off first and then will be booted with the provided rescue image.</p>
                                    <p>Are you sure you want to rescue the instance <b>{ this.props.instance.name }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" onClick={ () => this.onRescueClick() } id="setrescueBtn" >Rescue</button>
                                        <button className="btn btn_cancel" onClick={ this.rescueClose } >Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_slider marketApp_slider" id="appSlider">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper" >
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.closeAppSlider() } data-tip data-for="appStackClose"></div>
                            <ReactTooltip id="appStackClose">Close</ReactTooltip>
                            <div className={ "marketApp_slider_wrap " + this.state.appSlider.key + "_blk active" } >
                                <div className="head_block">
                                    <h2>Application Stack</h2>
                                </div>
                                <div className="marketApp_content_wrap">
                                    <div className="marketApp_titlebox">
                                        <div className="marketApp_titleboxContent">
                                            <div className={ "marketApp_icon " + this.state.appSlider.key?.replace(/\s+/, "") }>
                                                <i className="icon"></i>
                                            </div>
                                            <div className="marketApp_det">
                                                <h4>{ this.state.appSlider.name }</h4>
                                                <p><span>{ this.state.appSlider.version }</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="sql_table_blk">
                                        <h2>{ this.state.appSlider.heading }</h2>
                                        <p dangerouslySetInnerHTML={ { __html: this.state.appSlider.headingDesc } } ></p>
                                        { this.state.appSlider.packages.length > 0 && <h4>Packages Included</h4> }
                                        { this.state.appSlider.packages.length > 0 && <table>
                                            <tbody>
                                                <tr>
                                                    <th>Package</th>
                                                    <th>Version</th>
                                                    <th>License</th>
                                                </tr>
                                                { this.state.appSlider.packages.map((item, i) =>
                                                    <tr key={ i }>
                                                        <td>{ item.name }</td>
                                                        <td><a target="_blank" href={ item.verHref }>{ item.version }</a></td>
                                                        { item.lisHref ? <td><a target="_blank" href={ item.lisHref }>{ item.licesnse }</a></td> : <td>{ item.licesnse }</td> }
                                                    </tr>
                                                ) }
                                            </tbody>
                                        </table>
                                        }
                                    </div>
                                    <div className="lamp_deploy_desc">
                                        <h2>{ this.state.appSlider.heading01 }</h2>
                                        <ul>{ this.state.appSlider.heading01Desc && this.state.appSlider.heading01Desc.map((item, l) =>
                                            <li key={ l }>
                                                <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                            </li>
                                        ) }

                                        </ul>
                                        { this.state.appSlider.heading1Desc.length > 0 && <h2>Getting Started after deploying { this.state.appSlider.name }</h2> }
                                        <p> { this.state.appSlider.heading1 }</p>
                                        <ul> { this.state.appSlider.heading2Desc.map((item, j) =>
                                            <li key={ j }>
                                                <a href={ item.desc } target="_blank">{ item.desc }</a>
                                            </li>
                                        ) }

                                        </ul>
                                        <ul className="disk_list">
                                            { this.state.appSlider.heading1Desc.map((item, i) =>
                                                <li key={ i }>
                                                    <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                                </li>
                                            ) }
                                        </ul>
                                        { this.state.appSlider.restInfo && <p dangerouslySetInnerHTML={ { __html: this.state.appSlider.restInfo } } ></p> }

                                    </div>
                                    { this.state.appSlider.heading3 && <div className="lamp_deploy_desc">
                                        <h2>{ this.state.appSlider.heading3 }</h2>
                                        <ul className="disk_list">
                                            { this.state.appSlider.heading3Desc.map((item, i) =>
                                                <li key={ i }>
                                                    <p dangerouslySetInnerHTML={ { __html: item.desc.key } } ></p>
                                                </li>
                                            ) }
                                        </ul>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section >
        );
    }
}
function getPsswdStrength(psswd) {
    const strongPwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

    if(strongPwd.test(psswd)) {
        return "Strong";
    }
    // if (mediumPwd.test(psswd)) {
    //     return "Average"
    // }
    return "Weak";
}

export default Rescue;